<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cloudMiningId" label="项目ID"> </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column label="发放数量">
        <template slot-scope="scope">
          {{ BigNumber(scope.row.amount).toFixed() }} {{ scope.row.coinType }}
        </template>
      </el-table-column>
      <el-table-column label="持有数量">
        <template slot-scope="scope">
          {{ scope.row.holdAmount }} {{ scope.row.holdCoinType }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="理论收益">
        <template slot-scope="scope">
          {{ BigNumber(scope.row.price).toFixed() }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">未转账</span>
          <span v-else-if="scope.row.status === 1">已转账</span>
          <span v-else-if="scope.row.status === 2">已过期</span>
          <span v-else-if="scope.row.status === 3">转账中</span>
          <span v-else-if="scope.row.status === 4">转账失败</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'miningRecord',
  computed: {
    ...mapState('miningbonus', ['totalCount', 'pagination', 'records'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('miningbonus', ['getRecords']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
